import { createAction, props } from '@ngrx/store';
import { User } from '@app/core/interfaces';
import { State } from './auth.reducer';

export const UpdateUserAuthDetails = createAction(
  '[Auth] Updating User Auth Details',
  props<{ isAuthenticated: boolean, user: User | null }>()
)

/**
 * Asks the effects to rehydrate from Amplify's stored session on startup. Restoring is
 * asynchronous — Amplify may have to exchange a refresh token — so unlike the previous
 * synchronous read of sessionStorage it cannot be answered by the init action itself.
 */
export const SessionRestoreRequested = createAction(
  '[Auth] Session Restore Requested'
);

export const AuthInitialized = createAction(
  '[Auth] Auth Initialized',
  props<{ state: State; }>()
);

export const LogoutRequested = createAction(
  '[Auth] Logout Requested'
);

export const LogoutSuccess = createAction(
  '[Auth] Logout Success'
);

export const LogoutFailure = createAction(
  '[Auth] Logout Failure',
  props<{ error: any; }>()
);
